import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ValidatorsService } from 'src/app/shared/services/validators.service';

export interface ILoginForm {
  email: string;
  password: string;
}

@Component({
    selector: 'auth-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss'],
    standalone: false
})
export class LoginFormComponent implements OnInit {
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();

  patternReference: any = {};


  @Output()
  onSubmit: EventEmitter<ILoginForm> = new EventEmitter<ILoginForm>();

  get emailPlaceHolder(): string {
    return this.translationService.translate('Auth.Email');
  }

  get passwordPlaceHolder(): string {
    return this.translationService.translate('Auth.Password');
  }

  constructor(
    private fb: FormBuilder,
    //private translate: TranslateService,
    public validators: ValidatorsService,
    private translationService: TranslationService) { }

  ngOnInit() {
    /*
    this.form = this.fb.group({
      'email': ['', this.validators.formBuilderValidationInitializer(true, null, true)],
      'password': ['', this.validators.formBuilderValidationInitializer(true)]
    });
    */
    this.form = this.fb.group({
      email: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, true),
        updateOn: 'change'
      }),
      password: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      email: null,
      password: null
    };
    */
    this.patternReference = {
      email: null,
      password: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);
  }

  submit() {

    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    if (!this.form.valid)
            return;

    this.formErrors.clear();

    this.onSubmit.emit({
      email: this.form.get("email").value,
      password: this.form.get("password").value
    });
  }
}
